import { IFilterContent } from '../lists/listTypes';

export enum BookingListViewType {
    TABLE = 'TABLE',
    STATISTICS = 'STATISTICS',
    CALENDAR = 'CALENDAR',
}

export enum BookingStatusKey {
    COMMITTED = 'COMMITTED',
    CANCELLED = 'CANCELLED',
}

export enum BookingStatusColor {
    COMMITTED = '#1f9b42',
    CANCELLED = '#b50027',
}

export interface BookingListItem {
    Id: string;
    IdStatus: number;
    Status: string;
    StatusColor: BookingStatusColor;
    StatusKey: BookingStatusKey;
    BookingCode: string;
    IdSupplierHotel: number;
    SupplierHotel: string;
    CheckInDate: string | Date;
    CheckOutDate: string | Date;
    BookingDate: string | Date;
}

export interface BookingsFiltersState {
    IdStatus: IFilterContent;
    BookingCode: IFilterContent;
    IdSupplierHotel: IFilterContent;
    BookingDateFrom: IFilterContent;
    BookingDateTo: IFilterContent;
    CheckInDateFrom: IFilterContent;
    CheckInDateTo: IFilterContent;
    CheckOutDateFrom: IFilterContent;
    CheckOutDateTo: IFilterContent;
}
